import React, { useContext } from 'react';
import PropTypes, { shape } from 'prop-types';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import { Alert } from '@thd-olt-component-react/alert';
import { CheckNearByStore } from './CheckNearbyStore';
import { productShape } from '../../helpers/pod-fulfillment-utils';

export const BOSS = ({
  product,
  onCheckNearbyStoresClick
}) => {
  const {
    channel
  } = useContext(ExperienceContext);

  const { storeId, storeName } = useStore();

  if (!(product && storeId)) {
    return null;
  }

  return (
    <>
      {/* eslint-disable */}
      <Alert type="success" message="Free ship to store " inline/>&nbsp;for pickup
      {channel === 'mobile' && (
        <div className="store-name__wrapper">
          {storeName}
        </div>
      )}
      {channel !== 'mobile' && (
        <div className="store__new-line">
          {storeName} | <CheckNearByStore
            product={product}
            onCheckNearbyStoresClick={onCheckNearbyStoresClick}
          />
        </div>
      )}
    </>
  );
};

BOSS.propTypes = {
  product: PropTypes.shape({ productShape }).isRequired,
  onCheckNearbyStoresClick: PropTypes.func,
};

BOSS.defaultProps = {
  onCheckNearbyStoresClick: null
};
